import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { FadeUp } from '../motion/FadeUp';
import { KrayaLogo } from '../brand/KrayaLogo';
const KRAYA_APP = 'https://cdn.magicpatterns.com/patterns/generated-images/ae1be58a-7204-47cb-b7ae-bd632500f806.jpg';
export function Product() {
  return <section id="product" className="w-full bg-white px-6 py-28 md:py-36 lg:px-8" data-id="element-153" data-mp="1afv80bejeejt">
      <div className="mx-auto max-w-6xl" data-id="element-154" data-mp="15gimpv3bdfjc">
        <FadeUp data-id="element-155" data-mp="15hjwzxci9y00">
          <p className="text-center text-xs font-medium uppercase tracking-[0.24em] text-vermillion" data-id="element-156" data-mp="15i25ptgcu4ot">
            Our Product
          </p>
        </FadeUp>

        <FadeUp delay={0.08} data-id="element-157" data-mp="vr7hwkngmx19">
          <div className="mt-8 overflow-hidden rounded-[20px] border border-black/[0.08] bg-white shadow-[0_1px_2px_rgba(0,0,0,0.04),0_16px_48px_-24px_rgba(0,0,0,0.18)]" data-id="element-158" data-mp="vqfiszunmh68">
            <div className="grid items-stretch lg:grid-cols-2" data-id="element-159" data-mp="mog2k9rgrh4c">
              {/* Copy */}
              <div className="flex flex-col justify-center p-10 md:p-14 lg:p-16" data-id="element-160" data-mp="hrfvpwmsiac6">
                <KrayaLogo data-id="element-161" data-mp="26ayhgutgpepc" />
                <h3 className="mt-8 text-3xl font-semibold tracking-tightest text-ink md:text-4xl" data-id="element-162" data-mp="26aot1bo2fflr">
                  Discover local, together.
                </h3>
                <div className="mt-5 space-y-4 text-lg leading-relaxed text-ink/60" data-id="element-163" data-mp="1xbbsj8hx61d6">
                  <p data-id="element-164" data-mp="229wjehba78oy">
                    Kraya is our flagship consumer platform designed to make discovering
                    local places and everyday experiences more rewarding, social, and
                    enjoyable.
                  </p>
                  <p data-id="element-165" data-mp="2tzrfqxxk3yn4">
                    Built around real-world interactions, Kraya brings together technology,
                    community, and local businesses to help people connect beyond their
                    screens.
                  </p>
                </div>
                <div className="mt-9" data-id="element-166" data-mp="14lv2ghhruwk4">
                  <a href="https://kraya.xyz" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3 text-[15px] font-medium text-white transition-colors hover:bg-black" data-id="element-167" data-mp="14ktgvj34qro5">
                    Visit Kraya
                    <ArrowUpRightIcon className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" data-id="element-168" data-mp="gprfsucq4oja" />
                  </a>
                </div>
              </div>

              {/* App visual */}
              <div className="relative flex items-center justify-center overflow-hidden border-t border-black/[0.06] bg-[#fafafa] p-10 lg:border-l lg:border-t-0" data-id="element-169" data-mp="6twtnp9akbbr">
                <img src={KRAYA_APP} alt="The Kraya app displayed on a smartphone, showing a map and local place cards." className="max-h-[460px] w-auto object-contain drop-shadow-[0_24px_48px_rgba(0,0,0,0.12)]" loading="lazy" data-id="element-170" data-mp="3tycny1dlq6hx" />
              </div>
            </div>
          </div>
        </FadeUp>
      </div>
    </section>;
}